import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useMoralisDapp } from "providers/MoralisDappProvider/MoralisDappProvider";
import { useMoralis } from "react-moralis";
import { Button } from "antd";

import ConnectWallet from "./ConnectWallet";

function NFTComponentPass(props) {
  const history = useHistory();
  const claimFunction = "noOfAirdroppedNFT";
  const claimNFTFunction = "claim";

  const [show, setShow] = useState(false);
  const [showWallet, setShowWallet] = useState(false);
  const { marketAddress, contractABI, walletAddress } = useMoralisDapp();
  const contractABIJson = JSON.parse(contractABI);
  const { authenticate, isAuthenticated } = useMoralis();
  const { Moralis } = useMoralis();

  const item = props.item;

  const redirectToDetails = (id, name) => {
    history.push({
      pathname: "/nftDetail",
      search: "?name=" + name,
      state: { id: id, name: name },
    });
  };

  async function claim() {
    if (!isAuthenticated) {
      setShowWallet(true);
    } else {
      const ops = {
        contractAddress: marketAddress,
        functionName: claimFunction,
        abi: contractABIJson,
        params: {
          account: walletAddress,
        },
      };
      try {
        const res = await Moralis.executeFunction(ops);
        if (res[0] > res[1]) {
          claimNFT();
        } else {
          setShow(true);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
  async function claimNFT() {
    const ops = {
      contractAddress: marketAddress,
      functionName: claimNFTFunction,
      abi: contractABIJson,
      params: {
        account: walletAddress,
      },
    };
    try {
      const res = await Moralis.executeFunction(ops);
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="container my-5 py-4">
      {showWallet && <ConnectWallet />}
      <div
        className={
          item.nftId % 2 === 0 ? "card-container-odd" : " card-container-even"
        }
      >
        <h2 className="card-title mb-5">{item.name}</h2>
        <p className="card-text">{item.description}</p>
        <div className="row">
          <div className="col-6">
            <Button
              className="primary-button buy-button text-white s-btn"
              onClick={() => redirectToDetails(item.nftId, item.name)}
              size="large"
            >
              BUY NOW
            </Button>
          </div>
          <div className="col-6">
            {item.nftId === 2 && (
              <div>
                <Button
                  className="primary-button buy-button text-white s-btn mb-5"
                  size="large"
                  onClick={() => claim()}
                >
                  CLAIM
                </Button>
                {show && (
                  <p className="text-danger">You are not eligible to claim</p>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="card-image">
          <div className="img-box collection-box mb-3">
            <img src={item.image} alt="Longhorn NFT Drop" className="p-5"></img>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NFTComponentPass;
